<template>
    <v-text-field
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Search"
        class="hidden-sm-and-down pl-10 ml-4"
    />
</template>

<script>
export default {
    name: "SearchBar"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Search/SearchBar.vue